const ConfigPrice = ({ data, onEnquire }) => {
  return (
    <section id="price" className="py-6 bg-white">  
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-semibold text-[#090C6A] mb-8">
          Configuration & Pricing
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.configurations.map((item, i) => (
            <div
              key={i}
              className="border p-6 rounded-xl shadow-sm bg-white"
            >
              <h3 className="text-xl font-semibold">{item.type}</h3>
              <p>Carpet Area: {item.area} sq.ft</p>
              <p className="font-bold mt-2">{item.price}</p>
              <button className="mt-4 bg-[#090c6a] hover:bg-[#1218A6] text-white px-6 py-2 rounded" onClick={onEnquire}>
                Enquire Now
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConfigPrice;